import {
  getAction,
  postAction,
  deleteAction,
  putAction
} from '../http'

export default {
  //分页查询项目标签视图
  list(params = {}, column, sortRule) {
    return getAction(`/api/design/viewProjectTag/list?column=${column}&order=${sortRule}`, params);
  },

  queryById(params = {}) {
    return getAction('/api/design/viewProjectTag/queryById/', params);
  },

  queryByProjectId(params = {}){
    return getAction('/api/design/project/queryById',params);
  },

  //ComponentProjectTag
  getListByFrameworkId(params = {}) {
    return getAction('/api/design/viewProjectTag/listByFrameworkId', params);
  },

  //查询所有项目标签视图
  queryAll(params = {}) {
    return deleteAction('/api/design/viewProjectTag/queryAll', params);
  },

  listByUser(params = {}) {
    return getAction('/api/design/viewProjectTag/listByUser', params);
  },
  listWithPage(params = {}) {
    return getAction(`/api/design/viewProjectTag/list`, params);
  },
}